export const UPDATE_TAGS = 'updateTags'
export const TOGGLE_SELECT_TAG = 'toggleSelectTag'
export const UPDATE_SELECT_TAG = 'updateSelectTag'
export const UPDATE_KEYWORD = 'updateKeyWord'
